import darkScrollbar from "@mui/material/darkScrollbar";

const theme = (isDarkMode) => ({
  palette: {
    mode: isDarkMode ? "dark" : "light",
    primary: {
      main: "#9200FF",
    },
    secondary: {
      main: "#F8485E",
    },
    error: {
      main: "#f44336",
    },
  },
  components: {
    typography: {
      fontFamily: [
        "Open Sans",
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: isDarkMode ? darkScrollbar() : null,
      },
    },
  },
});

export default theme;
